export enum ValidationErrorType {
  DUPLICATE = "duplicate",
  INVALID_FORMAT = "invalid-format",
  REQUIRED = "required",
  NOT_FOUND = "not-found",
  UNKNOWN = "unknown",

  ALREADY_EXISTS = "already-exists",
  TOKEN_MISMATCH = "token-mismatch",
  UNAUTHORIZED = "unauthorized",
  emailNotVerified = "emailNotVerified"
}
